
import { productWebSocketMsg } from '@/util/busUtil'

/**
 * CONNECTING：值为0，表示正在连接。 OPEN：值为1，表示连接成功，可以通信了。 CLOSING：值为2，表示连接正在关闭。 CLOSED：值为3，表示连接已经关闭，或者打开连接失败。
 * @type {string}
 */
let webSocket = ''
let setIntervalWeSocketPush = null
let webUrl = ''

/**
 * 建立websocket连接
 * @param {string} url ws地址
 */
export const createSocket = url => {
  webUrl = url
  webSocket && webSocket.close()
  console.log(webSocket)
  if (!webSocket) {
    console.log('建立websocket连接')
    webSocket = new WebSocket(url)
    webSocket.onopen = onOpenWS
    webSocket.onmessage = onMessageWS
    webSocket.onerror = onErrorWS
    webSocket.onclose = onCloseWS

    // 监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常。
    window.onbeforeunload = onCloseWS
  } else {
    console.log('websocket已连接')
  }
}

/** 打开WS之后发送心跳 */
const onOpenWS = () => {
  sendPing()
}

/** 连接失败重连 */
const onErrorWS = () => {
  clearInterval(setIntervalWeSocketPush)
  console.log('连接失败重连中')
  if (webSocket.readyState === 3) {
    webSocket = ''
    createSocket(webUrl)
  }
}

/** WS数据接收统一处理 */
const onMessageWS = e => {
  productWebSocketMsg(e.data)
}

/**
 * 发送数据但连接未建立时进行处理等待重发
 * @param {any} message 需要发送的数据
 */
const connecting = message => {
  setTimeout(() => {
    if (webSocket.readyState === 0) {
      connecting(message)
    } else {
      webSocket.send(JSON.stringify(message))
    }
  }, 1000)
}

/**
 * 发送数据
 * @param {any} message 需要发送的数据
 */
export const sendWSPush = message => {
  if (webSocket !== null && webSocket.readyState === 3) {
    webSocket.close()
    createSocket(webUrl)
  } else if (webSocket.readyState === 1) {
    webSocket.send(JSON.stringify(message))
  } else if (webSocket.readyState === 0) {
    connecting(message)
  }
}

/** 断开重连 */
export const onCloseWS = () => {
  clearInterval(setIntervalWeSocketPush)
  webSocket = ''
}
/** 发送心跳
 * @param {number} time 心跳间隔毫秒 默认5000
 * @param {string} ping 心跳名称 默认字符串ping
 */
export const sendPing = (time = 20000, ping = 'ping') => {
  clearInterval(setIntervalWeSocketPush)
  webSocket.send(ping)
  setIntervalWeSocketPush = setInterval(() => {
    webSocket.send(ping)
  }, time)
}



// WEBPACK FOOTER //
// ./src/staticJs/webSocket.js